import PropTypes from 'prop-types';
import get from 'lodash/get';
import { capitalize } from "lodash";

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import CircleIcon from '@mui/icons-material/Circle';
import Typography from '@mui/material/Typography';

import CaseFilters, { SortButton } from './CaseFilters';
import CasesTable from './CasesTable';
import CustomAccordionStatusFilter from "../common/CustomAccordionStatusFilter";
import CaseStatus from "./CaseStatus";
import LoadingScreen from '../common/LoadingScreen';
import useIsMobile from '../../hooks/useIsMobile';
import config from '../../config/config';
import {getCaseStatusOptions} from '../../helpers/cases';

const TableView = props => {
  if (props.isLoading) return <LoadingScreen />;
  return (
    <Box>
      <CasesTable
        {...props}
        rows={(props.cases || []).map(s => ({ data: s }))}
      />
    </Box>
  );
};

const getTabOptions = status => {
  let options;
  switch (status) {
    case 'all':
      options = {
        Icon: CircleIcon,
        color: config().colors.light,
        name: 'All',
      };
      break;
    case 'active': 
      options = {
        Icon: CircleIcon,
        color: config().colors.primary,
        name: 'Active',
      };
      break;
    default:
      options = {
        Icon: CircleIcon,
        color: config().colors.success,
        name: 'Completed',
      };
  }
  return options;
};

const CaseTab = props => {
  console.log('CAseTab', props);
  const {color, Icon, name} = getTabOptions(props.status);
  return (
    <Stack
      direction='row'
      spacing={{xs: 1.5}}
      alignItems='center'
      onClick={props.onClick || undefined}
    >
      <Icon style={{fill: color, width: '15px', height: '15px'}} />
      {
        <Typography
          variant='normal'
          noWrap
        >
          {name} ({props.statusCount})
        </Typography>
      }
    </Stack>
  );
}

const CaseTabs = props => {
  const { tab, tabs } = props;
  const tabFilters = tabs;

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'start', sm: 'center' }}
      columns={{ xs: 1 }}
      columnGap={{md: 4.25, lg: 8.75}}
      rowGap={{ xs: 0, md: 2 }}
      padding={{ xs: 0, md: 1 }}
      useFlexGap
    >
      {tabFilters
        .map(t =>
          <div
            onClick={() => { props.onTabChange(t) }}
          >
            <CaseTab
              status={t}
              active={t === tab}
              statusCount={props.counts[t]}
            />
          </div>
        )
      }
    </Stack>
  );
};

const ListCasesScreen = props => {
  const { tab } = props;
  const tabName = tab !== 'all' ? capitalize(tab) : 'All Cases';
  const { color, Icon } = getCaseStatusOptions(tabName);
  const isMobile = useIsMobile();
  return (
    <Box className="list-session" marginTop='12px'>
      <CaseFilters
        filters={props.filters}
        isPatient={props.isPatient}
        onFilterChange={props.onFilterChange}
      />
      <Card className="list-session__card drop-shadow">
        <CardContent>
          <Box>
            <Box sx={{ display: {xs: 'none', md: 'block'}, marginLeft: '0.365rem'}}>
              <CaseTabs {...props} />
              {props.isUpdating && 
                <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems='center'>
                  <CircularProgress size={20} />
                  <Typography variant='body2' color='text.gray'>Refreshing</Typography>
                </Stack>
              }
            </Box>

            <Box sx={{ display: {xs: 'block', md: 'none'}}}>
              <CustomAccordionStatusFilter
                SummaryIcon={Icon}
                summaryColor={color}
                iconUrl="/images/logo-180px.png"
                summaryName={tabName}
                count={props.counts[tab]}
                DetailComponent={() => <CaseTabs {...props} />}
              />
            </Box>
            <Stack direction='row' justifyContent={'end'}>
              <Box sx={{ display: {xs: 'block', sm: 'none'}}}>
                <Box sx={{ marginRight: '0.875rem' }}>
                  <SortButton
                    sort={props.filters.sort}
                    onChange={sort => props.onFilterChange({ ...props.filters, sort })}
                  ></SortButton>
                </Box>
              </Box>
            </Stack>
          </Box>
          {Object.keys(props.cases).map(k =>
            tab === k
              ? <TableView
                isLoading={props.isLoading}
                isUpdating={props.isUpdating}
                title={`${k.toUpperCase()[0]}${k.slice(1)}`}
                category={k}
                cases={props?.cases?.[k] || []}
                pageSize={props.pageSize}
                pageIndex={get(props, `pageIndex[${k}]`) || 0}
                count={get(props, `counts[${k}]`)}
                onPageChange={props.onPageChange(k)}
                afterSave={get(props, `queries[${k}].refetch`) || null}
                isMobile={isMobile}
              />
              : null
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

ListCasesScreen.propTypes = {
  filters: PropTypes.object,
  tab: PropTypes.string,
  counts: PropTypes.object,
};

export default ListCasesScreen;
